module.exports = __webpack_public_path__ + "img/pres-07.a7ae4564.png";